<template>
  <product-form :value="product" :title="pageTitle" @submit="save">
    <template slot="actions">
      <form-button kind="submit" type="submit" @click="goToVariants">Enregistrer et gérer les déclinaisons</form-button>
      <form-button kind="default" type="submit" @click="goToProducts">Enregistrer</form-button>
      <form-button kind="cancel" @click="$router.go(-1)">Annuler</form-button>
    </template>
  </product-form>
</template>

<script>
  import ProductForm from './ProductForm.vue';

  import ProductCreateMutation from './graphql/ProductCreateMutation.gql';

  export default {
    components: {
      ProductForm,
    },
    data() {
      const {collection = null, kind = null, search = null} = this.$route.query || {};
      return {
        product: {
          name: search,
          kind: kind || 'clothing',
          collection: {id: collection},
          order: 50,
          published: false,
        },
        toVariants: false,
      };
    },
    methods: {
      async save(data) {
        try {
          const {data: {productCreate: product}} = await this.$apollo.mutate({
            mutation: ProductCreateMutation,
            variables: {
              data,
            },
          });

          this.$store.dispatch('addNotificationSuccess', `Le produit a été créé !`);
          this.$router.push(this.toVariants? {name: 'product/variants', params: {id: product.id} }: {name: 'products'});

        } catch (err) {
          if (err.message.match(/duplicate/)) {
            return this.$store.dispatch('addNotificationError', `L'alias est déjà utilisé par un autre produit !`);
          }
          this.$store.dispatch('addNotificationError', err.message);
        }
      },
      goToVariants() {
        this.toVariants = true;
      },
      goToProducts() {
        this.toVariants = false;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/products/ProductCreate.vue